/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertRuleDto } from '../../models/alert-rule-dto';

export interface AlertsQueryQueryDefinitionIdGet$Plain$Params {
  queryDefinitionId: string;
}

export function alertsQueryQueryDefinitionIdGet$Plain(http: HttpClient, rootUrl: string, params: AlertsQueryQueryDefinitionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertRuleDto>>> {
  const rb = new RequestBuilder(rootUrl, alertsQueryQueryDefinitionIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('queryDefinitionId', params.queryDefinitionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AlertRuleDto>>;
    })
  );
}

alertsQueryQueryDefinitionIdGet$Plain.PATH = '/alerts/query/{queryDefinitionId}';
